import React from 'react';
import { Icon } from './Icon';

export type BadgeProps = {
  className?: string;
  label?: string;
  badgeType: 'info' | 'error' | 'warning' | 'success';
};

/**
 * Badges indicate a status and/or should draw the attention of the user on a specific element.
 *
 * @param className additional className for the badge
 * @param label the optional text to display in the badge
 * @param badgeType the type of the badge, defining the color and icon
 * @param props leftover props
 */
export function Badge({
  className = '',
  label,
  badgeType,
  ...props
}: Readonly<BadgeProps>): JSX.Element {
  const badgeClassName = ['ehs-badge', className, badgeType].join(' ');
  const icon = () => {
    switch (badgeType) {
      case 'error':
        return <Icon iconName="shui-cancel" aria-label="" />;
      case 'warning':
        return <Icon iconName="shui_warning" aria-label="" />;
      case 'success':
        return <Icon iconName="shui_check" aria-label="" />;
      default:
        return <></>;
    }
  };

  return (
    <span {...props} className={badgeClassName}>
      {icon()}
      {label && <span>{label}</span>}
    </span>
  );
}
